async function d(o) {
  if (o.type === "image/png")
    return o;
  const n = new Image(), r = URL.createObjectURL(o);
  try {
    n.src = r;
    try {
      await n.decode();
    } catch (t) {
      const a = t instanceof Error ? `: ${t.name}${t.message ? `: ${t.message}` : ""}` : "";
      throw new DOMException(
        `Failed to load the image from the provided Blob${a}`,
        "InvalidStateError"
      );
    }
    const e = document.createElement("canvas");
    if (e.width = n.naturalWidth, e.height = n.naturalHeight, e.width === 0 || e.height === 0)
      throw new DOMException(
        `Cannot convert image to PNG: image has invalid dimensions ${e.width}x${e.height}`,
        "InvalidStateError"
      );
    const i = e.getContext("2d");
    if (!i)
      throw new Error("Failed to get canvas 2D context");
    return i.drawImage(n, 0, 0), await new Promise((t, a) => {
      e.toBlob((c) => {
        c ? t(c) : a(new Error("Failed to convert canvas to blob"));
      }, "image/png");
    });
  } finally {
    URL.revokeObjectURL(r);
  }
}
export {
  d as convertImageToPNG
};
